export const ADMIN_ROLES = ["manager", "finance", "tournaments"];

export const adminRoleLabelId = (role) => `gestion.admins.role.${role}`;
export const adminRoleHintId = (role) => `gestion.admins.role.hint.${role}`;

export const KNOWN_ADMIN_ERROR_CODES = [
  "already_administrator",
  "not_an_administrator",
  "locked_administrator",
  "self_locked",
  "last_manager",
  "no_area_selected",
];

export const adminErrorMessageId = (error) => {
  const code = error?.response?.data?.code;
  return KNOWN_ADMIN_ERROR_CODES.includes(code) ? `gestion.admins.error.${code}` : null;
};

export const emptyInviteForm = () => ({ lastName: "", firstName: "", email: "", phone: "", role: "tournaments" });

export const normalizePhone = (value) => String(value || "").replace(/[\s\-().]/g, "");

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_PATTERN = /^\+[1-9]\d{6,14}$/;

// Returns { field: messageId } for every invalid field; an empty object means the form is valid.
export const validateInviteForm = (form) => {
  const errors = {};
  const isBlank = (value) => String(value ?? "").trim() === "";

  if (isBlank(form.lastName)) errors.lastName = "gestion.admins.invite.required";
  if (isBlank(form.firstName)) errors.firstName = "gestion.admins.invite.required";

  if (isBlank(form.email)) {
    errors.email = "gestion.admins.invite.required";
  } else if (!EMAIL_PATTERN.test(form.email.trim())) {
    errors.email = "gestion.admins.invite.invalidEmail";
  }

  if (isBlank(form.phone)) {
    errors.phone = "gestion.admins.invite.required";
  } else if (!PHONE_PATTERN.test(normalizePhone(form.phone))) {
    errors.phone = "gestion.admins.invite.invalidPhone";
  }

  if (!ADMIN_ROLES.includes(form.role)) errors.role = "gestion.admins.invite.required";

  return errors;
};

export const buildInvitePayload = (form) => ({
  first_name: form.firstName.trim(),
  last_name: form.lastName.trim(),
  email: form.email.trim().toLowerCase(),
  phone: normalizePhone(form.phone),
  gestion_role: form.role,
});
